import { Store } from 'vuex';

import { logger } from '@app/logger';
import { addFederationRoutes } from '@app/router';
import { createErrorGuardConfig } from '@utils/ErrorGuard/storeConfig';
import {
    NavigationContext,
    NavigationContextProps,
    RouteActionItems,
} from '@superbet-group/web.types';
import { bannersService } from '../shared/sharedServiceInstances';

export async function initializeGamingFederation(store: Store<unknown>): Promise<void> {
    try {
        const gamingModule = await import('gaming/initializeFederation');
        await gamingModule.initializeFederation({
            addRoutes: addFederationRoutes,
            errorGuardConfig: createErrorGuardConfig(store),
            store,
            addTopLevelNavigation: (key: NavigationContext, value: NavigationContextProps) => {
                store.dispatch('navigation/addTopLevelNavigation', { key, value });
            },
            addMobileRouteActionItems: (routeActionItems: RouteActionItems) => {
                store.dispatch('navigation/addMobileRouteActionItems', routeActionItems);
            },
            fetchBanners(location: string, screen: string) {
                return bannersService.getBanners(location, screen);
            },
            experiments: {
                isNewTopLevelNavigationEnabled: true,
            },
        });
    } catch (error) {
        logger.error(error as Error);
    }
}
